import { render, staticRenderFns } from "./conflictType.vue?vue&type=template&id=01e18adc"
import script from "./conflictType.vue?vue&type=script&lang=js"
export * from "./conflictType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports